import ReactDOM from 'react-dom/client';
import EntryApp from './EntryApp';
import { I18nProvider } from './i18n/I18nProvider';
ReactDOM.createRoot(document.getElementById('root')!).render(<I18nProvider><EntryApp/></I18nProvider>);
